import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import LandingPage from "./pages/LandingPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import TicketView from "./pages/TicketView";
import PaymentReturn from "./pages/PaymentReturn";
import DisplayScreen from "./pages/DisplayScreen";
import BackstagePublic from "./pages/BackstagePublic";
import { AuthProvider } from "./context/AuthContext";
import { UserAuthProvider } from "./context/UserAuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import FloatingWhatsAppButton from "./components/FloatingWhatsAppButton";

// User account pages
import UserLogin from "./pages/user/UserLogin";
import UserRegister from "./pages/user/UserRegister";
import ForgotPassword from "./pages/user/ForgotPassword";
import ResetPassword from "./pages/user/ResetPassword";
import AccountPage from "./pages/user/AccountPage";
import FamilyPortal from "./pages/user/FamilyPortal";
import AuthCallback from "./pages/user/AuthCallback";
import VerifyEmail from "./pages/user/VerifyEmail";

import "./App.css";

function App() {
  return (
    <AuthProvider>
      <UserAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />

            {/* Buyer-facing auth & account */}
            <Route path="/login" element={<UserLogin />} />
            <Route path="/registar" element={<UserRegister />} />
            <Route path="/esqueci-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route path="/conta" element={<AccountPage />} />
            <Route path="/conta/familia" element={<FamilyPortal />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin/*"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/ticket/:ticketNumber" element={<TicketView />} />
            <Route path="/payment-return" element={<PaymentReturn />} />
            <Route path="/display" element={<DisplayScreen />} />
            <Route path="/backstage-display" element={<BackstagePublic />} />
          </Routes>
          <FloatingWhatsAppButton />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </UserAuthProvider>
    </AuthProvider>
  );
}

export default App;
